import { GHLLanguageKeys as e } from "./ghl-ui.es283.js";
const n = {
  name: e.german,
  global: {
    undo: "Rückgängig machen",
    redo: "Wiederholen",
    confirm: "Bestätigen Sie",
    clear: "Löschen",
    more: "mehr",
    cancel: "Stornieren"
  },
  Popconfirm: {
    positiveText: "Bestätigen",
    negativeText: "Abbrechen"
  },
  Cascader: {
    placeholder: "Bitte auswählen",
    loading: "Laden",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM-yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Löschen",
    now: "Jetzt",
    confirm: "Bestätigen Sie",
    selectTime: "Zeit auswählen",
    selectDate: "Datum auswählen",
    datePlaceholder: "Datum auswählen",
    datetimePlaceholder: "Datum und Uhrzeit wählen",
    monthPlaceholder: "Monat wählen",
    yearPlaceholder: "Jahr wählen",
    quarterPlaceholder: "Quartal wählen",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Enddatum",
    startDatetimePlaceholder: "Startdatum und Uhrzeit",
    endDatetimePlaceholder: "Enddatum und -uhrzeit",
    startMonthPlaceholder: "Monat beginnen",
    endMonthPlaceholder: "Ende Monat",
    monthBeforeYear: !0,
    firstDayOfWeek: 0,
    today: "Heute"
  },
  DataTable: {
    checkTableAll: "Alles in der Tabelle markieren",
    uncheckTableAll: "Alle in der Tabelle abwählen",
    confirm: "Bestätigen",
    clear: "Löschen",
    apply: "Anwenden",
    filters: "Filtern",
    sort: "Sortieren"
  },
  LegacyTransfer: {
    sourceTitle: "Quelle",
    targetTitle: "Ziel"
  },
  Transfer: {
    selectAll: "Alles auswählen",
    unselectAll: "Alle abwählen",
    clearAll: "Löschen"
  },
  Empty: {
    description: "Keine Daten"
  },
  Select: {
    placeholder: "Bitte auswählen"
  },
  TimePicker: {
    placeholder: "Zeit auswählen",
    positiveText: "OK",
    negativeText: "Abbrechen",
    now: "Jetzt"
  },
  Pagination: {
    goto: "Gehe zu",
    selectionSuffix: "Seite",
    next: "Nächste",
    previous: "Vorherige"
  },
  DynamicTags: {
    add: "hinzufügen"
  },
  Log: {
    loading: "Laden"
  },
  Input: {
    placeholder: "Bitte eingeben"
  },
  InputNumber: {
    placeholder: "Bitte eingeben"
  },
  DynamicInput: {
    create: "erstellen"
  },
  ThemeEditor: {
    title: "Themen-Editor",
    clearAllVars: "Alle Variablen löschen",
    clearSearch: "Suche löschen",
    filterCompName: "Komponentenname filtern",
    filterVarName: "Variablenname filtern",
    import: "Importieren",
    export: "Exportieren",
    restore: "Auf Standard zurücksetzen"
  },
  Image: {
    tipPrevious: "Vorheriges Bild (←)",
    tipNext: "Nächstes Bild (→)",
    tipCounterclockwise: "Gegen den Uhrzeigersinn",
    tipClockwise: "Im Uhrzeigersinn",
    tipZoomOut: "Verkleinern",
    tipZoomIn: "Einzoomen",
    tipClose: "Schließen (Esc)",
    tipOriginalSize: "Auf Originalgröße zoomen"
  },
  SortFilter: {
    heading: "Sortieren und filtern",
    sortHeading: "Sortieren nach",
    newestFirst: "Neueste zuerst",
    oldestFirst: "Älteste zuerst",
    ascending: "Aufsteigend",
    descending: "Absteigend",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Anwenden",
    clear: "Löschen",
    cancel: "Abbrechen",
    filters: "Filter"
  },
  IconPicker: {
    noMatchingFound: "Keine übereinstimmenden Ergebnisse gefunden"
  }
};
export {
  n as de
};
